// Settings > Study and focus > Background music: a built-in soundscape or your own uploaded
// tracks, volume, loop, and the uploads. Player is app/music.js;
// uploads live in IndexedDB (shared/music-store.js) and never leave this browser.
import { toggle, groupedSelect, range, button } from "../ui.js";
import { set } from "../../shared/settings-store.js";
import { MUSIC_PRESETS } from "../../shared/settings-schema.js";
import { addTracks, listTracks, removeTrack, clearTracks, subscribeTracks } from "../../shared/music-store.js";

function tracksControl() {
	const wrap = document.createElement("div");
	wrap.className = "rv-tracks";
	const listEl = document.createElement("div");
	listEl.className = "rv-tracks-list";

	function render() {
		listEl.textContent = "";
		const tracks = listTracks();
		if (!tracks.length) {
			const empty = document.createElement("div");
			empty.className = "rv-sched-empty";
			empty.textContent = "No uploads yet. Add music files to build your playlist.";
			listEl.appendChild(empty);
			return;
		}
		tracks.forEach((t) => {
			const rowEl = document.createElement("div");
			rowEl.className = "rv-track-row";
			const name = document.createElement("span");
			name.className = "rv-track-name";
			name.textContent = t.name;
			name.title = t.name;
			const rm = document.createElement("button");
			rm.type = "button";
			rm.className = "rv-sched-del";
			rm.setAttribute("aria-label", "Remove " + t.name);
			rm.textContent = "✕";
			rm.addEventListener("click", async () => { if (!await removeTrack(t.id)) alert("Couldn't remove that track. Check browser storage and try again."); });
			rowEl.append(name, rm);
			listEl.appendChild(rowEl);
		});
	}
	render();
	subscribeTracks(render);
	wrap.append(listEl);
	return wrap;
}

// Upload buttons and the playlist, in one block under Background music.
function uploadsControl() {
	const file = document.createElement("input");
	file.type = "file";
	file.accept = "audio/*";
	file.multiple = true;
	file.hidden = true;
	file.tabIndex = -1;
	file.setAttribute("aria-hidden", "true");

	let addBtn;
	async function pick() { file.value = ""; file.click(); }
	file.addEventListener("change", async () => {
		if (!file.files || !file.files.length) return;
		const label = addBtn && addBtn.textContent;
		if (addBtn) { addBtn.textContent = "Adding…"; addBtn.disabled = true; }
		try {
			const res = await addTracks(file.files);
			if (res.added) { set("musicPreset", "uploads"); set("musicEnabled", true); }
			if (res.failed) alert(res.failed + " file(s) could not be saved. Check available browser storage and try again.");
			if (res.skipped) alert(res.skipped + " file(s) were skipped (not audio, too large, or the limit was reached).");
		} catch (e) {
			alert("Couldn't add those files.");
		} finally {
			if (addBtn) { addBtn.textContent = label; addBtn.disabled = false; }
		}
	});

	addBtn = button("Add music…", pick);
	const clearBtn = button("Remove all", async () => { if (listTracks().length && confirm("Remove all uploaded tracks?") && !await clearTracks()) alert("Couldn't remove the tracks. Check browser storage and try again."); }, "rv-btn-danger");
	const btns = document.createElement("div");
	btns.className = "rv-btnrow";
	btns.append(addBtn, clearBtn, file);
	const wrap = document.createElement("div");
	wrap.className = "rv-music-uploads";
	const hint = document.createElement("div");
	hint.className = "rv-row-desc";
	hint.textContent = "Pick “My uploads” under Sound to play them.";
	wrap.append(btns, tracksControl(), hint);
	return wrap;
}

export const musicControls = {
	musicEnabled: () => toggle("musicEnabled"),
	musicPreset: () => groupedSelect("musicPreset", [
		{ label: "Soundscapes", options: MUSIC_PRESETS.map((m) => [m.id, m.label]) },
		{ label: "Your music", options: [["uploads", "My uploads"]] },
	]),
	musicVolume: () => range("musicVolume", 0, 100, 1, (v) => v + "%"),
	musicLoop: () => toggle("musicLoop"),
	musicUploads: uploadsControl,
};
